import $ from 'jquery';

import {
	getDOMElements,
	restCall,
	parseStringWithTokens,
	getUnsavedFieldsValues,
	isCustomValue
} from '../common/utilities.js';

import Modal    from '../common/modal.js';

import {
	validateItemFields,
} from '../validation/validation.js';

import Triggers from './triggers.js';
import Actions  from './actions.js';

class ItemOptions {
	constructor( itemId, optionId ){
		this.itemId   = itemId;
		this.optionId = optionId;
		this.item 	  = UncannyAutomator.recipe.items[ itemId ];

		// Array to save the Field objects
		this.fields   = this.item.options[ this.optionId ].fields;
		// Array to save the buttons
		this.buttons  = this.item.options[ this.optionId ].buttons;

		this.create();

		// AFTER we added the elements to the DOM let's call init 
		// TokenSelector, TinyMCE and CodeMirror. We're going to call this in
		// ItemOptions.js because the TokenSelector, TinyMCE and 
		// CodeMirror need the item in the DOM before changing it
		// Select2 and the URL checker are called in Field.js
		this.initTokenSelector();
		this.initTinyMCE();
		this.initFlatpickr();
		this.initCodeMirror();

		// Dispatch custom event when everything is rendered
		document.dispatchEvent(
			new CustomEvent(
				'automator/item/options/open',
				{
					detail: {
						itemId: this.itemId,
						librariesReady: true
					}
				}
			)
		);
	}

	create(){
		// Container
		let container = getDOMElements( 'item', {
			id: this.itemId
		}).contentContainer;

		let itemOptions	= $( '<div/>', { 'class': 'item-options' });

		// Buttons. We have to create these before the fields, but append after
		let buttons = this.createButtons();

		// Fields
		let fields = this.createFields();
		this.fieldsContainer = fields;
		itemOptions.append( fields );

		// Create notices container
		let noticeContainer  = $( '<div/>', { 'class': 'item-options__notices' });
		this.noticeContainer = noticeContainer;
		itemOptions.append( noticeContainer );

		// Append buttons
		itemOptions.append( buttons );

		// Append to the item
		container.html( itemOptions );
	}

	createFields(){
		let container = $( '<div/>', { 'class': 'item-options__group' });

		// Create fields
		$.each( this.fields, ( index, field ) => {
			// Get field type
			let fieldType = field.getAttributes().fieldType;

			// Check if it's a repeater
			if ( fieldType == 'repeater' ){
				// Create the fields again first (to avoid showing unsaved changed)
				field.createFields();
			}

			// Append the form element to the DOM
			field.createFormElement();
			container.append( field.getFormElement() );

			// Bind submit on Enter (for all except groups and textareas)
			if ( ! [ 'textarea', 'repeater' ].includes( fieldType ) ){
				// Get field element and bind 'keyup'
				field.getField().on( 'keyup', ( event ) => {
					// Check if it's an enter
					if ( event.keyCode == 13 ){
						// Trigger a click on the Save Button
						this.saveButton.trigger( 'click' );
					}
				});
			}
			else if ( fieldType == 'repeater' ){
				// Iterate rows
				field.fieldRows.forEach(( row, index ) => {
					// Iterate each row
					row.forEach(( Field, index ) => {
						// Get field element and bind 'keyup'
						Field.getField().on( 'keyup', ( event ) => {
							// Check if it's an enter
							if ( event.keyCode == 13 ){
								// Trigger a click on the Save Button
								this.saveButton.trigger( 'click' );
							}
						});
					});
				});
			}
		});

		return container;
	}

	createButtons(){
		// Buttons
		let container 	  	 = $( '<div/>', { 'class': 'item-options__buttons' });

		// Actions buttons
		let automatorButtons = $( '<div/>', { 'class': 'item-options__uo-buttons' }),
			developerButtons = $( '<div/>', { 'class': 'item-options__developer-buttons' });

		let saveButton 	  	 = $( '<div/>', { 'class': 'uap-btn uap-btn--primary item-options-button-save' }),
			cancelButton  	 = $( '<div/>', { 'class': 'uap-btn uap-btn--secondary' }).text( UncannyAutomator._core.i18n.cancel );

		if ( this.item.itemType == 'trigger' ){
			saveButton.text( UncannyAutomator._core.i18n.save );
		}

		if ( this.item.itemType == 'action' ){
			saveButton.text( UncannyAutomator._core.i18n.save );
		}

		if ( this.item.itemType == 'closure' ){
			saveButton.text( UncannyAutomator._core.i18n.save );
		}

		this.saveButton = saveButton;

		automatorButtons.append( saveButton );
		automatorButtons.append( cancelButton );

		// Check developer defined buttons
		$.each( this.buttons, ( index, button ) => {
			// Create button
			const $buttonElement = $( '<div/>', { 'class': 'uap-btn' }).text( button.text );

			// Check if we have to add a custom class to the button
			if ( _uo.utility.isDefined( button.css_classes ) ){
				// Add classes
				$buttonElement.addClass( button.css_classes );
			}

			// Check if it has a defined onClick function
			let doOnClick = () => {};
			if ( _uo.utility.isDefined( button.on_click ) ){
				// Try to overwrite empty function
				try {
					// Try to convert the string to function, but first remove the <script> tags and trim the string
					doOnClick = eval( `(${ button.on_click.replace( '<script>', '' ).replace( '</script>', '' ).trim() })` ); 
				} catch ( e ){
					// Continue regardless of error
		
					// Output error if the developer mode is enabled
					if ( UncannyAutomator._site.has_debug_enabled ){
						// eslint-disable-next-line no-console
						console.warn( e );
						console.warn( button.on_click );
					}
				}
			}

			// Listen clicks on the button
			$buttonElement.on( 'click', () => {
				// Invoke callback
				doOnClick(
					// button
					$buttonElement,
					// data
					{
						item:      this.item,
						values:    getUnsavedFieldsValues( { 
							itemType: this.item.itemType,
							itemID: this.itemId 
						} ),
					},
					// modules
					(function(){
						// Get required modules
						let modules = {};

						// Check if the developer wants custom modules
						if ( _uo.utility.isDefined( button.modules ) ){
							// Check if we have to add the modal module
							if ( button.modules.includes( 'modal' ) ){
								// Include modal
								modules.Modal = Modal;
							}
						}

						// Return modules
						return modules;
					})()
				);
			});

			// Add button to the container
			developerButtons.append( $buttonElement );
		});

		container.append( automatorButtons );
		container.append( developerButtons );

		saveButton.on( 'click', () => {
			// Verify form
			let formValidation = validateItemFields( this.fieldsContainer );

			if ( ! formValidation.isValid ){
				return;
			}
		
			// Disable button and show loading animation
			saveButton.addClass( 'uap-btn--loading uap-btn--disabled' );

			// The REST call wants:
			// - The item ID
			// - The option code (the one from the token, the main one)
			// - The value. If there is more than one then a serialized object
			let itemId 		= this.itemId,
				optionCode 	= this.optionId,
				optionValue = this.getOptionValue();

			// Get a temporary item sentence
			// This must use values that are not yet saved in the meta of the item
			const itemSentence = parseStringWithTokens( this.item, this.item.meta.sentence, $.extend({}, this.item.meta, getUnsavedFieldsValues( { itemType: this.item.itemType, itemID: this.itemId } ) ) );

			// Get the item sentence HTML
			let itemSentenceHTML;
			try {
				itemSentenceHTML = itemSentence.html.get(0).outerHTML;
			} catch ( e ){
				// Continue regardless of error
	
				// Output error if the developer mode is enabled
				if ( UncannyAutomator._site.has_debug_enabled ){
					// eslint-disable-next-line no-console
					console.warn( e );
				}
			}

			// Get item form element
			const $item = getDOMElements( 'item', {
				id: this.item.id
			}).item.get(0);

			const updateParams = {
				recipe_id: UncannyAutomator._recipe.recipe_id,
				itemId:       itemId,
				optionCode:   optionCode,
				optionValue:  optionValue,
				sentence_human_readable: itemSentence.brackets,
				sentence_human_readable_html: itemSentenceHTML,
				options: this.options
			};

			// Check if type is trigger and add itemCode.
			if ( this.item.itemType == 'trigger' ){
				updateParams.trigger_item_code = this.item.itemCode;
			}

			restCall( 'update', updateParams, ( response ) => {
				// Clear the cache of tokens
				UncannyAutomator._cache.tokens = [];
				
				// Trigger "saved" on all item fields
				this.fields.forEach(( Field ) => {
					Field.getFormElement().trigger( 'saved' );
				});

				// Check if the item is valid
				const itemIsValid = UncannyAutomator.recipe.items[ this.item.id ].isValid;

				// Check if we should render the UI right away, if if we should update the status first
				// Check if the item is valid
				if ( itemIsValid ) {
					// Exception for walkthrough `create-recipe`
					if ( UncannyAutomator._core.recipe.walkthrough.getCurrentWalkthrough()?.id == 'tour--create-recipe' ) {
						// Render the UI
						if ( this.item.itemType == 'trigger' ){
							new Triggers();
						}
						
						if ( this.item.itemType == 'action' || this.item.itemType == 'closure' ){
							new Actions();
						}
					} else {
						if ( 
							// Check if the recipe is NOT live yet
							( ! UncannyAutomator._recipe.is_recipe_on ) &&
							// Check if the item isn't already live
							( ! this.item.isLive )
						) {
							try {
								const $statusToggle = $item.querySelector( '.uap-item-status input[type="checkbox"]' );
					
								// Make it live
								$statusToggle.checked = true;
								$statusToggle.dispatchEvent( new Event( 'change' ) );
							} catch ( e ) {
								// Output error if the developer mode is enabled
								if ( UncannyAutomator._site.has_debug_enabled ){
									// eslint-disable-next-line no-console
									console.warn( e );
								}
					
								// Render the UI
								if ( this.item.itemType == 'trigger' ){
									new Triggers();
									new Actions();
								}
					
								if ( this.item.itemType == 'action' || this.item.itemType == 'closure' ){
									new Actions();
								}
							}
						} else {
							// Render the UI
							if ( this.item.itemType == 'trigger' ){
								new Triggers();
								new Actions();
							}
					
							if ( this.item.itemType == 'action' || this.item.itemType == 'closure' ){
								new Actions();
							}
						}
					}

					// Send custom event to the document
					document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/item-updated', {
						detail: {
							itemID: itemId,
							itemType: this.item.itemType,
							integrationCode: this.item.integrationCode,
							itemCode: this.item.itemCode,
							options: this.options
						}
					} ) );

				} else {
					// Render the UI
					if ( this.item.itemType == 'trigger' ){
						new Triggers();
					}
					
					if ( this.item.itemType == 'action' || this.item.itemType == 'closure' ){
						new Actions();
					}
					
					// Get item form element
					const $newItem = getDOMElements( 'item', {
						id: this.item.id
					}).item.get(0);
					
					// Open the first non valid group of fields
					const $options = $newItem.querySelectorAll( '.item-title__token:not(.item-title__token--filled)' );
					if ( _uo.utility.isDefined( $options[0] ) ) {
						$options[0].click();
					}
				}
				
			}, ( response ) => {
				// Reset UI
				if ( this.item.itemType == 'trigger' ){
					new Triggers();
				}

				if ( this.item.itemType == 'action' || this.item.itemType == 'closure' ){
					new Actions();
				}

				// Try to open the options again
				try {
					// Get the item elements
					getDOMElements( 'item', {
						id: this.itemId
					})
					// Get the main container
					.item
					// Find the token in the sentence
					.find( `.item-title__token[data-options-id="${ optionCode }"]` )
					// Trigger a click
					.trigger( 'click' ); 
				} catch ( e ){
					// Continue regardless of error
	
					// Output error if the developer mode is enabled
					if ( UncannyAutomator._site.has_debug_enabled ){
						// eslint-disable-next-line no-console
						console.warn( e );
					}
				}
			});
		});

		// Handle the cancel button
		cancelButton.on( 'click', () => {
			// Remove the options
			getDOMElements( 'item', { id: this.itemId }).contentContainer
				.html( '' );

			// Get item
			const $item = getDOMElements( 'item', { id: this.item.id } ).item;

			// Remove open classes
			$item.removeClass( 'uap-item--open' );
			$item.find( '.item-title__token--open' )
				.removeClass( 'item-title__token--open' );
				
			// Get item form element
			$item.trigger( 'automator:item:open', false );

			// Dispatch custom event when everything is rendered
			document.dispatchEvent(
				new CustomEvent(
					'automator/item/options/close',
					{
						detail: {
							itemId: this.itemId,
							triggeredBy: 'cancel-button'
						}
					}
				)
			);
		});

		return container;
	}

	initTokenSelector(){
		$.each( this.fields, ( index, field ) => {
			// Get the field type
			field.initTokenSelector();		
		});
	}

	initTinyMCE(){
		const isInsideLoop = _uo.utility.isDefined( UncannyAutomator._core.recipe.item.loop.getParentLoop( this.itemId ) );
		
		$.each( this.fields, ( index, field ) => {
			// Get the field type
			if ( field.getAttributes().fieldType == 'textarea' ){
				// TinyMCE will be initialized only if it's a textarea and supportsTinyMCE is true
				field.initTinyMCE();

				// Check if the field is inside a loop
				if ( isInsideLoop ) {
					// Wait some time and try to initialize TinyMCE again
					setTimeout( () => {
						field.initTinyMCE();
					}, 1000 );
				}
			}
		});
	}

	initCodeMirror(){
		$.each( this.fields, ( index, field ) => {
			// Get the field type
			field.initCodeMirror();
		});
	}

	/**
	 * Init flatpickr in all date & time fields
	 */
	initFlatpickr(){
		$.each( this.fields, ( index, field ) => {
			// Get the field type
			field.initFlatpickr();
		});
	}

	/**
	 * Creates the object that will be sent to the backend to save the fields
	 * 
	 * @return {Object} The options data, including options group ID and the fields values
	 */
	get options() {
		const fields = {};

		this.fields.forEach( field => {
			const fieldAttributes = field.getAttributes();

			// Get basic field data
			const fieldSummary = {
				type:  fieldAttributes.fieldType,
				value: field.getValue()
			}

			if ( fieldSummary.type === 'select' ) {
				// Check if it supports multiple values
				fieldSummary[ 'supports_multiple_values' ] = fieldAttributes.supportsMultipleValues;
				fieldSummary[ 'supports_custom_value' ] = fieldAttributes.supportsCustomValue;

				// Check if it has a custom value
				if ( isCustomValue( fieldSummary.value ) ) {
					// Check for multiSelect
					if ( fieldAttributes.supportsMultipleValues ) {
						fieldSummary[ 'value' ] = 'automator_custom_value';
					}
					// Set custom value
					fieldSummary[ 'custom_value' ] = field.getSelectCustomValue();
				}
			}

			if ( fieldSummary.type === 'select' || fieldSummary.type === 'radio' || fieldSummary.type === 'file' ) {
				// Save readable value if it's not a custom value.
				if ( ! isCustomValue( fieldSummary.value ) ) {
					fieldSummary[ 'value_readable' ] = field.getReadableValue();
				}
			}

			if ( fieldSummary.type === 'textarea' ) {
				// Check if it supports HTML
				fieldSummary[ 'supports_tinymce' ] = fieldAttributes.supportsTinyMCE;
			}

			if ( fieldSummary.type === 'textarea' ) {
				// Check if it supports HTML
				fieldSummary[ 'supports_markdown' ] = fieldAttributes.supportsMarkdown;
			}

			fields[ fieldAttributes.optionCode ] = fieldSummary;
		} );

		return {
			groupCode: this.optionId,
			fields: fields
		};
	}

	/**
	 * Returns the data that has to be saved in the trigger/action meta
	 */
	getOptionValue(){
		let response = {},
			hasSelect = false,
			hasRepeater = false;

		$.each( this.fields, ( index, field ) => {
			let id 	  = field.getAttributes().optionCode,
				value = field.getValue();

			if ( [ 'select', 'radio' ].includes( field.getAttributes().fieldType ) ){
				// Has select
				hasSelect = true;

				// Check if it's a multiselect
				// Then save the value as a JSON string, don't save it
				// as an array
				if ( field.getAttributes().supportsMultipleValues ){
					try {
						value = JSON.stringify( value );
						value = isCustomValue( value )
							? 'automator_custom_value'
							: value;

					} catch ( e ){
						// Continue regardless of error
		
						// Output error if the developer mode is enabled
						if ( UncannyAutomator._site.has_debug_enabled ){
							// eslint-disable-next-line no-console
							console.warn( e );
						}
					}
				}

				// Save readable value
				response[ `${ id }_readable` ] = field.getReadableValue();

				// Check if we have to save the custom value (only for selects)
				if ( isCustomValue( value ) ){
					response[ `${ id }_custom` ] = field.getSelectCustomValue();
				}
			}
			else if ( field.getAttributes().fieldType == 'repeater' ){
				// Has repeater
				hasRepeater = true;
				
				// Convert data to a JSON string
				value = JSON.stringify( value );
			} else if ( field.getAttributes().fieldType === 'file' ) {
				// Convert data to a JSON string
				value = JSON.stringify( value );

				// Save readable value
				response[ `${ id }_readable` ] = field.getReadableValue();
			}

			response[ id ] = value;
		});

		if ( ! hasRepeater && ! hasSelect && Object.keys( response ).length == 1 ){
			// One field
			response = response[ Object.keys( response )[ 0 ] ];
		}

		return response;
	}
}

export default ItemOptions;